
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/department-selection.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/department-selection.md?type=demo')
};